import {observable, action, makeObservable} from 'mobx';
import uuid from 'uuid';

class ToastNotificationsStore {
  @observable notifications = [];

  @action
  addNotification = async ({message, type}) => {
    const id = uuid();
    this.notifications = [...this.notifications, {message, type, id}];

    // Remove the notification after 10 seconds
    await new Promise(resolve => {
      window.setTimeout(resolve, 10000);
    });
    this.removeNotification(id);
  };

  @action
  removeNotification = id => {
    this.notifications = this.notifications.filter(notification => notification.id !== id);
  };

  setStore = store => {
    this.store = store;
  };

  constructor() {
    makeObservable(this);
  }
}

export default ToastNotificationsStore;
